// extracted by mini-css-extract-plugin
module.exports = {"partTimeWrapper":"EditUserAvailabilityForm_partTimeWrapper__19pBb"};